import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 清理缓存
export const clearCache: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post(payload.postUrl, payload.params);
    store.commit('common/setToast', { visible: true, text: '清除成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 刷新索引
export const refreshIndex: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.get(`${payload.postUrl}?updateStructure=${payload.rebuild}`);
    store.commit('common/setToast', { visible: true, text: '更新成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 更新缩略图
export const updateThumb: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/image/processing', payload);
    await $http.post('/v1/system/image/uploadimg', payload);
    store.commit('common/setToast', { visible: true, text: '更新成功' });
  } finally {
    commit('setLoading', false);
  }
};
